import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentStepIndex,
  selectCurrentSubstepIndex,
  selectTravelRenewalFlowType,
  selectPlanChanged,
  setCurrentStepIndex,
  setCurrentSubstepIndex,
  setTravelRenewalFlowType,
  setPlanChanged,
  resetTravelRenewalFlow,
} from "../redux/features/travelRenewalFlowSlice";

// Flow type constant
export const TRAVEL_RENEWAL_FLOW = "TRAVEL_RENEWAL_FLOW";

// Step name constants
export const TRAVEL_RENEWAL_REVIEW_POLICY = "TRAVEL_RENEWAL_REVIEW_POLICY";
export const TRAVEL_RENEWAL_SELECT_PLAN = "TRAVEL_RENEWAL_SELECT_PLAN";
export const TRAVEL_RENEWAL_ENHANCE_COVERAGE = "TRAVEL_RENEWAL_ENHANCE_COVERAGE";
export const TRAVEL_RENEWAL_REVIEW_CONFIRM = "TRAVEL_RENEWAL_REVIEW_CONFIRM";

// Redux form keys for storing selected data
export const TRAVEL_RENEWAL_SELECTED_POLICY = "TRAVEL_RENEWAL_SELECTED_POLICY";
export const TRAVEL_RENEWAL_SELECTED_PLAN = "TRAVEL_RENEWAL_SELECTED_PLAN";
export const TRAVEL_RENEWAL_SELECTED_COVERS = "TRAVEL_RENEWAL_SELECTED_COVERS";

const useTravelRenewalFlow = () => {
  const dispatch = useDispatch();
  const flowType = useSelector(selectTravelRenewalFlowType);
  const currentStepIndex = useSelector((state) => selectCurrentStepIndex(state));
  const currentSubstepIndex = useSelector((state) => selectCurrentSubstepIndex(state));
  const planChanged = useSelector(selectPlanChanged);

  console.log(flowType, currentStepIndex, currentSubstepIndex, "travel renewal flow");

  const steps = travelRenewalFlow[flowType] || [];
  const currentStep = steps[currentStepIndex] || {};
  const currentSubstep = currentStep.substeps
    ? currentStep.substeps[currentSubstepIndex]
    : "";

  const handleFlowChange = (type, stepIndex = 0, substepIndex = 0) => {
    dispatch(
      setTravelRenewalFlowType({
        type,
        currentStepIndex: stepIndex,
        currentSubstepIndex: substepIndex,
      })
    );
  };

  const handleNextSubstep = () => {
    console.log("🔄 handleNextSubstep called");
    console.log("- currentStep:", currentStep);
    console.log("- currentStepIndex:", currentStepIndex);
    console.log("- currentSubstepIndex:", currentSubstepIndex);
    console.log("- substeps length:", currentStep.substeps?.length);
    console.log("- steps total:", steps.length);

    if (
      currentStep.substeps &&
      currentSubstepIndex < currentStep.substeps.length - 1
    ) {
      console.log("📈 Moving to next substep");
      dispatch(setCurrentSubstepIndex(currentSubstepIndex + 1));
    } else if (currentSubstepIndex === currentStep.substeps.length - 1) {
      console.log("📈 Moving to next step");
      handleNextStep();
    } else {
      console.log("⚠️ Cannot advance - no more steps");
    }
  };

  const handlePrevSubstep = () => {
    if (currentSubstepIndex > 0) {
      dispatch(setCurrentSubstepIndex(currentSubstepIndex - 1));
    } else {
      handlePrevStep();
    }
  };

  const handleNextStep = () => {
    console.log("🔄 handleNextStep called");
    console.log("- currentStepIndex:", currentStepIndex);
    console.log("- steps.length:", steps.length);

    if (currentStepIndex < steps.length - 1) {
      console.log("📈 Setting step index to:", currentStepIndex + 1);
      dispatch(setCurrentStepIndex(currentStepIndex + 1));
      dispatch(setCurrentSubstepIndex(0));
    } else {
      console.log("⚠️ Cannot advance - already at last step");
    }
  };

  const handlePrevStep = () => {
    if (currentStepIndex > 0) {
      const prevStep = steps[currentStepIndex - 1] || {};
      const substepIndex = prevStep?.substeps?.length - 1 || 0;
      dispatch(setCurrentStepIndex(currentStepIndex - 1));
      dispatch(setCurrentSubstepIndex(substepIndex));
    }
  };

  // Go to a specific step by index
  const goToStep = (stepIndex, substepIndex = 0) => {
    if (stepIndex >= 0 && stepIndex < steps.length) {
      dispatch(setCurrentStepIndex(stepIndex));
      dispatch(setCurrentSubstepIndex(substepIndex));
    }
  };

  // Set whether plan was changed
  const setHasPlanChanged = (changed) => {
    dispatch(setPlanChanged(changed));
  };

  // Reset the flow
  const resetFlow = () => {
    dispatch(resetTravelRenewalFlow());
  };

  return {
    handleFlowChange,
    handleNextSubstep,
    handlePrevSubstep,
    handleNextStep,
    handlePrevStep,
    goToStep,
    setHasPlanChanged,
    resetFlow,
    flowType,
    steps,
    currentStep,
    currentStepIndex,
    currentSubstep,
    currentSubstepIndex,
    planChanged,
  };
};

export default useTravelRenewalFlow;

// Flow definition - step 0 is Review Policy, step 1 is Select Plan, step 2 is Enhance Coverage, step 3 is Review Confirm
export const travelRenewalFlow = {
  [TRAVEL_RENEWAL_FLOW]: [
    {
      name: TRAVEL_RENEWAL_REVIEW_POLICY,
      substeps: [TRAVEL_RENEWAL_REVIEW_POLICY],
    },
    {
      name: TRAVEL_RENEWAL_SELECT_PLAN,
      substeps: [TRAVEL_RENEWAL_SELECT_PLAN],
    },
    {
      name: TRAVEL_RENEWAL_ENHANCE_COVERAGE,
      substeps: [TRAVEL_RENEWAL_ENHANCE_COVERAGE],
    },
    {
      name: TRAVEL_RENEWAL_REVIEW_CONFIRM,
      substeps: [TRAVEL_RENEWAL_REVIEW_CONFIRM],
    },
  ],
};
